var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64.000000pt",
    height: "64.000000pt",
    viewBox: "0 0 64.000000 64.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102 570 c-29 -12 -46 -54 -32 -80 11 -20 41 -40 60 -40 17 0 60 47 60 65 0 17 -43 65 -57 64 -4 0 -18 -4 -31 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 398 c-3 -8 -4 -86 -3 -173 l3 -160 53 -3 52 -3 -2 173 -3 173 -48 3 c-33 2 -49 -1 -52 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 235 l0 -175 50 0 50 0 0 103 c0 121 11 151 57 155 51 5 63 -23 63 -151 l0 -108 53 3 52 3 -1 130 c-1 181 -20 215 -122 215 -34 0 -57 -6 -75 -20 -25 -20 -25 -20 -30 0 -4 16 -14 20 -51 20 l-46 0 0 -175z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.779c790a2f41a597c11d4d22259c15cc.svg";
export { ForwardRef as ReactComponent };